import React, { useState, useEffect } from 'react';
import { css } from 'styled-components';
import { UitkButtonSize } from 'uitk-react-button';

//helpers
import { getDefaultValue } from 'src/components/common/helper';
import { ModuleProps } from 'src/components/common/module-util';

//components
import { Layout } from 'src/components/common/modules/layout/layout';
import { getDeviceImage, useProgressiveImg, tinyImage } from 'src/components/common/modules/layout/component';
import { checkValue, LightenDarkenColor } from 'src/components/common/helper';
import {
  mediaQueries,  
  //setFontSizeByModule,
  setModuleBackGround, 
} from 'src/components/common/modules/layout/component-styles';
import { PrimaryButton, PrimaryButtonProps } from 'src/components/common/ui/button/button';
import Figure from 'src/components/common/ui/figure/figure';

let bgImageSrcCkeck = '';

const CpCmsLitePromo = (props: ModuleProps) => {
  const {
    data: {
      cTAColor,
      cTACopy,
      cTACopyColor,
      cTALink,
      image,
      titleCopy,
      backgroundColor,
      backgroundImage,
      cTALinkSubpage,
      turnOffGradient,
      moduleStyle,
      backgroundImageOpacity,
      backgroundImageDescription = '',
      imageDescription = '',
    },
    id
  } = props;
  
  // Content url
  let cpCTAUrl = checkValue(cTALink) ? cTALink : '';
  if (typeof cTALinkSubpage !== 'string') {
    cpCTAUrl = checkValue(cTALinkSubpage) && checkValue(cTALinkSubpage[0]) ? cTALinkSubpage?.[0]?.url : cpCTAUrl;
    cpCTAUrl = cpCTAUrl.endsWith('/') ? cpCTAUrl.slice(0, -1) : cpCTAUrl;
  }
  const clickEventTarget = '_blank';
  const [windowWidth, setWindowwidth] = useState(0);

  const modulestyle = checkValue(moduleStyle)
    ? moduleStyle.toLowerCase().includes('right')
      ? 'right'
      : 'left'
    : 'left';
  const modulestylePosition = checkValue(moduleStyle)
    ? moduleStyle.toLowerCase().includes('top')
      ? 'top'
      : moduleStyle.includes('middle')
      ? 'center'
      : 'bottom'
    : 'top';

  useEffect(() => {
    if (window) {
      setWindowwidth(window.innerWidth);
      promoModule();

      window.addEventListener('resize', () => {
        setWindowwidth(window.innerWidth);
        promoModule();
      });
    }
  }, []);

  const primaryButtonProps: PrimaryButtonProps = {
    text: cTACopy,
    tag: 'a',
    gaTracking: {
      eventCategory: 'Button Click',
      eventAction: 'Promo',
      eventLabel: `${cTACopy}`,
    },
    exClass: `btn`,
    url: cpCTAUrl,
    target: clickEventTarget,
    size: UitkButtonSize.LARGE,
  };

  const promoModule = () => {
    const isMobile = windowWidth < 768;

    const sectionImageAltText = getDefaultValue(imageDescription, 'Promo Image');

    return (
      <>
        {isMobile ? (
          <>
            <div className="section-main">
              {checkValue(titleCopy) && <h2>{titleCopy}</h2>}
              <div className="section-image">
                {sectionImage !== '' && (
                  <Figure {...{ src: sectionImage, alt: sectionImageAltText, roundcorner: ['all'] }} />
                )}
                {checkValue(turnOffGradient) &&
                  sectionImage !== '' &&
                  (turnOffGradient === 'False' || turnOffGradient === false) && <div className="gradient"></div>}
              </div>
            </div>
            <PrimaryButton {...primaryButtonProps} />
          </>
        ) : (
          <>
            <div className="section-title">
              {checkValue(titleCopy) && <h2>{titleCopy}</h2>}
              <PrimaryButton {...primaryButtonProps} />
            </div>
            <div className="section-image">
              {sectionImage !== '' && (
                <Figure {...{ src: sectionImage, alt: sectionImageAltText, roundcorner: ['all'] }} />
              )}
              {checkValue(turnOffGradient) &&
                sectionImage !== '' &&
                (turnOffGradient === 'False' || turnOffGradient === false) && <div className="gradient"></div>}
            </div>
          </>
        )}
      </>
    );
  };

  const moduleCss = () => {

    const moduleBgColor = checkValue(backgroundColor) ? backgroundColor : '';
    const bgImage = checkValue(backgroundImage) ? getDeviceImage(backgroundImage, 'desktop') : '';
    const bgtabImage = checkValue(backgroundImage) ? getDeviceImage(backgroundImage, 'tablet') : '';
    const bgmobileImage = checkValue(backgroundImage) ? getDeviceImage(backgroundImage, 'mobile') : '';
    const bgTinyImage = checkValue(bgImage) ? tinyImage(bgImage, 'desktop') : '';
    const bgtabTinyImage = checkValue(bgtabImage) ? tinyImage(bgtabImage, 'tablet') : '';
    const bgmobileTinyImage = checkValue(bgmobileImage) ? tinyImage(bgmobileImage, 'mobile') : '';

    const [bgImageSrc] = useProgressiveImg(bgTinyImage, bgImage);
    const [bgTabImageSrc] = useProgressiveImg(bgtabTinyImage, bgtabImage);
    const [bgMobileImageSrc] = useProgressiveImg(bgmobileTinyImage, bgmobileImage);
    bgImageSrcCkeck = bgImageSrc;

    let opecityValue = 0;
    if (checkValue(backgroundImageOpacity)) {
      opecityValue = parseInt(backgroundImageOpacity) / 100;
    }

    let primaryDarkColor = '';
    if(checkValue(cTAColor)){
      primaryDarkColor = LightenDarkenColor(cTAColor, -0.1);
    }

    return `
              ${setModuleBackGround('.promo', moduleBgColor, bgImageSrc)}                             
            
              .promo .gradient{
                opacity:${opecityValue};
                background: linear-gradient(0deg, rgba(41, 49, 66, 0.5) 100%, rgba(41, 49, 66, 0.5) 100%) !important;
              }

              @media only screen and (max-width: ${mediaQueries.tab}) {
                ${setModuleBackGround('.promo', moduleBgColor, bgTabImageSrc)}
              }
              @media only screen and (max-width: ${mediaQueries.mobile}) {
                ${setModuleBackGround('.promo', moduleBgColor, bgMobileImageSrc)}
              }     
              
              .uitk-button-primary{              
                background-color:${checkValue(cTAColor)?cTAColor:''} !important;
                border-color: ${checkValue(cTAColor)?cTAColor:''} !important;
                color: ${checkValue(cTACopyColor)?cTACopyColor:''} !important;
                &:hover{
                  background-color: ${primaryDarkColor} !important;
                  border-color: ${primaryDarkColor} !important;
                }
              }
          `;
  };
  let sectionImage = checkValue(image) ? getDeviceImage(image, 'desktop') : '';
  sectionImage = sectionImage.replace('width=2016&height=1092', 'width=685&height=495');

  const backgroundImageAltText = getDefaultValue(backgroundImageDescription, `Promo Background Image`);

  return (
    <>
      {(checkValue(backgroundImage) || checkValue(image)) && (
        <Layout
          className="promo-section"
          css={css`
            ${moduleCss()}
          `}
          id={id}         
        >
          <div className="promo promo-webflow">
            <span aria-label={backgroundImageAltText} />
            {checkValue(bgImageSrcCkeck) && <div className="gradient"></div>}
            <div className="container">
              <div className={`promo-module promo-module--text-${modulestyle} ${modulestylePosition}`}>
                {promoModule()}
              </div>
            </div>
          </div>
        </Layout>
      )}
    </>
  );
};

export default CpCmsLitePromo;
